import { ConfigProvider, ConfigProviderProps } from "antd";

type AuthThemeProps = ConfigProviderProps;

export const AuthTheme = ({ theme, ...props }: AuthThemeProps) => {
  return (
    <ConfigProvider
      theme={{
        ...theme,
        token: {
          borderRadius: 4,
          colorBorder: "#D9D9D9",
          controlHeight: 40,
          ...theme?.token,
        },
        components: {
          Button: {
            fontWeight: 500,
            controlHeightLG: 48,
            ...theme?.components?.Button,
          },
          Card: {
            borderRadiusLG: 24,
          },
          ...theme?.components,
        },
      }}
      {...props}
    />
  );
};
